import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const close = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "currentColor",
    width: size || '1em',
    height: size || '1em'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M921 0L500 421 79 0 0 79l421 421L0 921l79 79 421-421 421 421 79-79-421-421 421-421-79-79z"
  }));
};
close.displayName = 'close';
export default close;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=close.js.map